import React from 'react';
import { FormattedMessage } from 'react-intl';
import { routePathMap } from '../common/routes/routePaths';
import TIRouteProps from '../common/routes/TIRouteProps';
import { NotesPage } from './NotesPage';
import { MyWorkIcon } from './icons/MyWorkIcon';

export const notesPageRoute: TIRouteProps = {
  path: routePathMap.notes,
  component: NotesPage,
  exact: false,
  title: <FormattedMessage id="tabs.myWork" />,
  icon: <MyWorkIcon />
};
